import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import 'hammerjs';
import 'zone.js';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { showOAuthLoadingOverlay } from './app/shared/oauth-loading-overlay';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
// if(environment.production){
//   platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch((err) => console.error(err));
// }

// Show spinner before Angular bootstraps on callback and logout reload
if (
  sessionStorage.getItem('oauth_callback_loading') === 'true' ||
  sessionStorage.getItem('oauth_logout_loading') === 'true'
) {
  showOAuthLoadingOverlay();
}

// SSR Enabled below
// Bootstrap the app (works for both SSR and client-side)
document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
